<template>
  <div class="wrapper">
    <div class="content">
      <div class="tableContainer">
        <el-table
          :data="dataList"
          border
          style="width: 100%"
          :cell-style="{ padding: '8px 0', fontSize: '14px' }"
        >
          <el-table-column prop="certificateName" label="人脸" width="180px">
            <template slot-scope="{ row }">
              <el-image
                v-if="row.faceurl"
                style="height: 180px; width: 180px"
                :src="row.faceurl"
                fit="contain"
              ></el-image>
              <view v-else>无人脸图片</view>
            </template>
          </el-table-column>
          <el-table-column prop="username" label="学员姓名" width="80px">
          </el-table-column>
          <el-table-column prop="idcard" label="身份证号" width="180px">
          </el-table-column>
          <el-table-column prop="mobile" label="手机号" width="180px">
          </el-table-column>
          <el-table-column align="center" width="120px" label="审核状态">
            <template slot-scope="{ row }">
              {{ ["未审核", "审核通过"][row.status] }}
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" width="180px">
          </el-table-column>
          <el-table-column prop="audittime" label="审核时间" width="180px">
          </el-table-column>
          <el-table-column align="center" width="120px" label="操作">
            <template slot-scope="{ row }">
              <el-button
                slot="reference"
                size="small"
                @click="
                  Object.assign(auditData, row);
                  auditData.ifShow = true;
                "
                >审核</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          @current-change="getData"
          @size-change="getData"
          :current-page.sync="searchCondition.pageNumber"
          :page-sizes="[10, 30, 100]"
          :page-size.sync="searchCondition.pageSize"
          :total="searchCondition.total"
          layout="total, sizes, prev, pager, next, jumper"
        >
        </el-pagination>
      </div>
    </div>

    <el-dialog
      title="审核"
      :visible.sync="auditData.ifShow"
      width="40%"
      :append-to-body="true"
    >
      <div class="totalContainer"></div>
      <div slot="footer">
        <el-button size="small" type="danger" @click="auditSubmit(false)"
          >不通过</el-button
        >
        <el-button size="small" type="primary" @click="auditSubmit(true)"
          >通过</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Util from "@/libs/util";
import {
  getManualFaceCheckList,
  manualFaceCheck,
} from "@/api/examination/examination.js";
export default {
  data() {
    return {
      searchCondition: {
        pageNumber: 1,
        pageSize: 10,
        examName: JSON.parse(this.$route.query.item).exName,
      },
      auditData: { ifShow: false },
      dataList: [],
    };
  },
  methods: {
    getData() {
      let postData = this.searchCondition;
      getManualFaceCheckList(this.searchCondition).then((data) => {
        this.dataList = data;
      });
    },
    auditSubmit(ifPass) {
      this.auditData.status = ifPass ? 1 : 0;
      console.log(this.auditData);
      manualFaceCheck(this.auditData).then((data) => {
        this.getData();
        this.$message.success("提交成功");
        this.auditData.ifShow = false;
      });
    },
  },
  created() {},
  mounted() {
    // console.log(JSON.parse(this.$route.query.item));

    this.getData();
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .searchBar {
    padding: 15px;
    background: #fff;
    display: flex;
    justify-content: space-between;
  }
  .content {
    margin-top: 15px;
    background: #fff;
    padding: 15px;
    .actBar {
      margin-bottom: 10px;
      display: flex;
      justify-content: space-between;
    }
  }
}
/deep/ .el-range-editor--small .el-range-input {
  width: 70px;
}
/deep/ .el-date-editor .el-range-separator {
  width: auto;
  padding: 0;
}
</style>
